import React from "react"
import { Timer } from "lucide-react"
import { useOrderTimer } from "../../hooks/useOrderTimer"
import type { Order } from "../../types"
import { getStatusIcon, getStatusText } from "./OrderCard"

interface PendingCollectionOrderCardProps {
    order: Order;
}

export const PendingCollectionOrderCard: React.FC<PendingCollectionOrderCardProps> = ({ order }) => {
    const timer = useOrderTimer(order);

    return (
        <div className="p-4 rounded-lg bg-yellow-50/50 dark:bg-yellow-900/20">
            <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg font-bold text-yellow-900 dark:text-yellow-100">
                    Orden #{order.order_number}
                </h3>
                <div className="flex flex-col items-end gap-2">
                    <div className="flex items-center gap-2 px-3 py-1 rounded-full backdrop-blur-sm bg-yellow-100/80 dark:bg-yellow-900/30">
                        {getStatusIcon(order.status || '')}
                        <span className="text-sm font-semibold text-yellow-700 dark:text-yellow-300">
                            {getStatusText(order.status || '')}
                        </span>
                    </div>
                    {timer && !timer.isOverdue && (
                        <div className="flex items-center gap-2 text-amber-600 dark:text-amber-400 font-mono font-bold bg-amber-50 dark:bg-amber-900/30 px-3 py-1 rounded-lg">
                            <Timer className="w-4 h-4" />
                            <span>{timer.timeLeft}</span>
                        </div>
                    )}
                </div>
            </div>

            {timer && !timer.isOverdue && (
                <div className="w-full bg-yellow-200/30 dark:bg-yellow-800/20 rounded-full h-1.5 mb-3 overflow-hidden">
                    <div
                        className="bg-amber-500 h-1.5 rounded-full transition-all duration-1000 ease-linear"
                        style={{ width: `${timer.progress}%` }}
                    />
                </div>
            )}

            <div className="space-y-2">
                {order.order_products.map((item, index) => {
                    const price = item.product_details?.price || item.offer_details?.price || 0;
                    const subProducts = item.product_details?.sub_products || [];

                    return (
                        <div
                            key={index}
                            className="flex flex-col gap-1.5 rounded-xl p-3 bg-yellow-50/80 dark:bg-yellow-900/20 border border-yellow-200/50 dark:border-yellow-800/30"
                        >
                            <div className="flex justify-between items-start">
                                <span className="font-bold text-sm text-yellow-900 dark:text-yellow-100 leading-tight">
                                    <span className="opacity-70 font-extrabold mr-1.5">{item.quantity}x</span>
                                    {item.product_details?.name || item.offer_details?.name || "Producto"}
                                </span>
                                <span className="text-sm font-semibold text-yellow-800 dark:text-yellow-200 ml-2">
                                    ${(price * item.quantity).toFixed(2)}
                                </span>
                            </div>
                            {subProducts.length > 0 && Array.isArray(subProducts) && (
                                <div className="flex flex-wrap gap-1 px-5">
                                    {subProducts.map((sub: any, idx: number) => (
                                        <span key={sub.uuid || sub.sub_product_uuid || idx} className="text-[10px] bg-white/50 dark:bg-black/20 text-yellow-800 dark:text-yellow-300 px-1.5 py-0.5 rounded-md font-bold uppercase tracking-wider border border-yellow-200/50 dark:border-yellow-800/50">
                                            {sub.name || sub.sub_product_name}
                                        </span>
                                    ))}
                                </div>
                            )}
                            {/* {item.observation && (
                                <p className="text-[11px] text-yellow-700/80 dark:text-yellow-400/80 italic px-5 leading-snug">
                                    💬 "{item.observation}"
                                </p>
                            )} */}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
